/**
 * Ancho del panel de ayuda (px). Debe coincidir con `PageHelpDrawer` (breakpoints sm/md).
 */
export const PAGE_HELP_DRAWER_WIDTH_PX = {
  sm: 420,
  md: 460,
} as const;
